export default __webpack_public_path__ + "8193aa8147dce13ddc66420a824a3c27.wasm";